import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { IDeleteIapRequest, IIap } from "../intefaces/IIap";

export interface IapState {
  currentPage: number;
  totalPage: number;
  perPage: number;
  loading: boolean;
  data: IIap[];
  dataList: IIap[];
  error: string;
}

const initialState: IapState = {
  loading: false,
  data: [],
  dataList: [],
  error: "",
  currentPage: 1,
  totalPage: 0,
  perPage: 20,
};

export const iapSlice = createSlice({
  name: "iap",
  initialState,
  reducers: {
    getIaps: (state, action) => {
      state.loading = true;
      state.error = "";
    },
    getIapSuccess: (
      state,
      action: PayloadAction<{
        data: IIap[];
        totalPage: number;
        currentPage: number;
      }>
    ) => {
      state.loading = false;
      state.data = action.payload.data;
      state.dataList = action.payload.data;
      state.error = "";
      state.totalPage = action.payload.totalPage;
      state.currentPage = action.payload.currentPage;
    },
    getIapFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
      state.data = [];
    },
    deleteIap: (state, action: PayloadAction<IDeleteIapRequest>) => {},
    deleteIapSuccess: (state, action: PayloadAction<IDeleteIapRequest>) => {
      state.dataList = state.dataList.filter(
        (x) => !action.payload.id.includes(x._id)
      );
    },
    deleteIapFaild: () => {},
    selectPage: (state, action: PayloadAction<number>) => {
      state.currentPage = action.payload;
      const start = (action.payload - 1) * state.perPage;
      const end = start + state.perPage;
      state.dataList = state.data.slice(start, end);
    },
  },
});

export const {
  getIaps,
  getIapSuccess,
  getIapFailure,
  selectPage,
  deleteIap,
  deleteIapSuccess,
  deleteIapFaild,
} = iapSlice.actions;

export default iapSlice.reducer;
